import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EXHIBIT_TYPE as EXHIBITTYPE } from "./../../../../../../../utils/constant.utils";
import { requestDetailsActions } from "./../../../../../../../store/external/request-reducer/request-details.reducer";
import { NewCircuitDetails } from "./wireline-new-circuit-details.component";
import { NewCircuitExhibitBDetails } from "./new-circuit-exhibit-b-detail.component";

class NewCircuitDetailDisplay extends Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {

        await this.props.getExhibitType();
    }

    displayForm = () => {

        const { exhibitType } = this.props.requestDetail;
        let form;

        // if (exhibitType == EXHIBITTYPE.exhibitA) {
        //     form = <NewCircuitDetails data={this.props.data} />
        // } else if (exhibitType == EXHIBITTYPE.exhibitB) {
        //     form = <NewCircuitExhibitBDetails data={this.props.data} />
        // } else {
        //     form = null;
        // }

        form = <NewCircuitDetails openRequestModal={this.props.openRequestModal} data={this.props.data} path={this.props.path} />

        return (form);
    }

    render() {
        return (
            <div>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { requestDetail } = state;
        return {
            requestDetail
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, requestDetailsActions),
            dispatch
        )
)(NewCircuitDetailDisplay);